import { useEffect } from "react";
import { C, font } from "../tokens";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SectionPill from "../components/SectionPill";
import CtaButton from "../components/CtaButton";

export default function NotFound() {
  useEffect(() => {
    document.title = "Página não encontrada | IMOBMEET";
  }, []);

  return (
    <div style={{ fontFamily: font, background: C.white, color: C.text, overflowX: "hidden" }}>
      <Navbar />

      <section style={{ padding: "120px 28px 140px", textAlign: "center" }}>
        <div style={{ maxWidth: 560, margin: "0 auto" }}>
          <SectionPill>Erro 404</SectionPill>
          <h1 style={{ fontFamily: font, fontSize: 40, fontWeight: 800, lineHeight: 1.15, letterSpacing: -1.2, color: C.text, marginBottom: 14 }}>
            Essa página ainda não existe.
          </h1>
          <p style={{ fontFamily: font, fontSize: 16, color: C.muted, lineHeight: 1.6, marginBottom: 32 }}>
            O link que você seguiu pode estar desatualizado, ou a página ainda está sendo construída. Volte para a home ou fale com a gente para agendar uma demonstração.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <CtaButton to="/">Voltar para a Home</CtaButton>
            <CtaButton to="/agendar-demo" primary={false}>Agendar demonstração →</CtaButton>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
